import React from "react";

export default function UniversalLoader() {
  return (
    <div className="loader-4 center">
      <span></span>
    </div>
  );
}
